export default function EmptyState() {
  return (
    <div className="flex items-center justify-center h-52">
      <div className="text-center">
        <h2 className="text-xl font-medium text-gray-900 mb-2">
          No blog posts found
        </h2>
        <p className="text-gray-600">Check back later for new content!</p>
      </div>
    </div>
  );
}
